import React from 'react';
//import { MasterTermVersionsProvider } from '../../MasterTermVersion/Provider/MasterTermVersionsProvider';
import AgreementNotificationsPageContent from '../../AgreementNotifications/Components/AgreementNotificationsPageContent';

export default function AgreementNotificationsPage() {
    return (
        <AgreementNotificationsPageContent />
    );
}
